export const usePreloaderStore = defineStore('preloader', () => {
	const progress = ref(0)
	const isComplete = ref(false)
	const videoStates = ref<Record<string, boolean>>({})
	const videoUrls = ref<Record<string, string>>({})

	function setProgress(value: number) {
		progress.value = Math.min(100, Math.max(0, value))
	}

	function setVideoLoaded(videoId: string, url?: string) {
		videoStates.value[videoId] = true
		if (url) {
			videoUrls.value[videoId] = url
		}
	}

	function isVideoLoaded(videoId: string) {
		return videoStates.value[videoId] || false
	}

	function getVideoUrl(videoId: string) {
		return videoUrls.value[videoId] || null
	}

	function complete() {
		isComplete.value = true
		progress.value = 100
	}

	function reset() {
		progress.value = 0
		isComplete.value = false
		videoStates.value = {}
		videoUrls.value = {}
	}

	return {
		progress,
		isComplete,
		videoStates,
		videoUrls,
		setProgress,
		setVideoLoaded,
		isVideoLoaded,
		getVideoUrl,
		complete,
		reset,
	}
})

